import React from 'react';
import PropTypes from 'prop-types';
import PhotoAlbum from 'react-photo-album';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';

import PageSectionHeader from './SectionHeader';

import { thumbnailPlaceholder } from '../../helpers/Collections';
import { isValidUrl } from '../../helpers/Validators';

const imgStyle = {
  transition: 'transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s',
};

const cont = {
  backgroundColor: '#eee',
  cursor: 'pointer',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
};

const imageRenderer = ({
  index,
  left,
  top,
  key,
  photo,
  imageProps: { alt, style, ...restImageProps },
}) => {
  const LinkTag = photo.customUrl ? 'a' : Link;

  return (
    <LinkTag
      to={LinkTag === 'a' ? undefined : photo.targeturl}
      href={LinkTag === 'a' ? photo.targeturl : undefined}
      key={`${index}-${key}`}
      left={left}
      top={top}
      style={{
        ...cont,
      }}
    >
      <img
        style={{
          marginBottom: 10,
          marginTop: 10,
          width: style.width,
          ...imgStyle,
          ...restImageProps,
        }}
        alt={photo.title}
        src={photo.src}
      />
      <div className="photo-gallery-content">
        <div className="photo-gallery-qty">
          <i className="fas fa-clone" />
          <span>{photo.files}</span>
        </div>
        <div className="photo-gallery-header">
          {photo.subtitle && (
            <span className="photo-gallery-date">
              {photo.subtitle}
            </span>
          )}
          {photo.title && (
            <h3>{photo.title}</h3>
          )}
        </div>
      </div>
    </LinkTag>
  );
};

imageRenderer.propTypes = {
  key: PropTypes.any.isRequired,
  index: PropTypes.any.isRequired,
  left: PropTypes.any.isRequired,
  top: PropTypes.any.isRequired,
  photo: PropTypes.any.isRequired,
  imageProps: PropTypes.any.isRequired,
  customUrl: PropTypes.bool.isRequired,
};

const PageSectionCollectionsGrid = ({ section, isLoggedIn }) => {
  if (section.collections.length === 0) {
    return null;
  }

  const photos = section.collections.map(collection => (
    {
      src: collection.featured_file ? `${collection.featured_file.urls.thumbnailmasonry}#c=${collection.uuid}` :
        thumbnailPlaceholder,
      width: collection.featured_file ? collection.featured_file.width : 900,
      height: collection.featured_file ? collection.featured_file.height : 600,
      files: collection.files,
      title: collection.title,
      subtitle: collection.subtitle,
      targeturl: (!isLoggedIn && isValidUrl(collection.custom_url)) ? collection.custom_url : `/collections/${collection.uuid}`,
      customUrl: !isLoggedIn && isValidUrl(collection.custom_url),
    }
  ));

  return (
    <div className="custom-page-section landing-gallery">
      <Container>
        <PageSectionHeader section={section} />
        <PhotoAlbum
          targetRowHeight={400}
          photos={photos}
          columns={(containerWidth) => {
            if (containerWidth < 320) return 1;
            if (containerWidth < 1200) return 2;
            return 3;
          }}
          layout="masonry"
          renderPhoto={imageRenderer}
          componentsProps={{
            columnContainerProps: { style: { alignItems: 'center' } },
          }}
        />
      </Container>
    </div>
  );
};

PageSectionCollectionsGrid.propTypes = {
  section: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default PageSectionCollectionsGrid;
